import React, { FC, useMemo, useState } from 'react';
import { Spin, Select as AntdSelect } from 'antd';
import { debounce } from 'lodash';

import Select from '@ui/Select';
import usePaginate from '@hooks/usePaginate';
import { IInfiniteScrollSelectProps, ILoadSelectOption } from './interfaces';

const { Option } = AntdSelect;

const InfiniteScrollSelect: FC<IInfiniteScrollSelectProps> = ({
  /** Апи функция */
  api,
  /** Параметры для апи функции */
  values,
  /** Функция для мапинга данных в формат options для селекта */
  mapper,
  /** Наименование параметра, передаваемого в api() для поиска в селекте */
  searchParamName,
  /** Загружать первую страницу при инифиализации */
  fetchOnInit = true,
  ...props
}) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const { data, loadMore, isLoading, hasNext, refetchData } = usePaginate<any>({
    call: api,
    values,
    skip: !fetchOnInit,
  });

  const handleOnSearch = async (value: string) => {
    const trimValue = value.trim();
    setSearchValue(trimValue);

    if (searchParamName) {
      refetchData({ ...values, [searchParamName]: trimValue });
    }
  };

  const handleSelectScroll = async event => {
    const { target } = event;
    if (
      !isLoading &&
      hasNext &&
      target.scrollTop + target.offsetHeight + 10 >= target.scrollHeight
    ) {
      target.scrollTo(0, target.scrollHeight);

      const searchParams = searchParamName
        ? { [searchParamName]: searchValue.trim() }
        : {};
      await loadMore(searchParams);
    }
  };

  const options: any[] = useMemo(
    () => (mapper && data ? mapper(data, searchValue) : []),
    [data, mapper, searchValue]
  );

  return (
    // @ts-ignore
    <Select
      {...props}
      showSearch
      optionFilterProp="children"
      filterOption={false}
      onSearch={debounce(handleOnSearch, 500)}
      loading={isLoading}
      notFoundContent={isLoading ? <Spin size="small" /> : null}
      onPopupScroll={handleSelectScroll}
    >
      {options.map(({ label, value, _id, ...optionProps }) => (
        <Option value={value} key={_id} {...optionProps}>
          {label}
        </Option>
      ))}
      {isLoading && (
        <Option value="loading" disabled>
          Загрузка...
        </Option>
      )}
    </Select>
  );
};

export default InfiniteScrollSelect;
